// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import { ContentLoader, Markdown, Icon, Cuttable, Link } from '@plesk/ui-library';
import { useContext, SyntheticEvent } from 'react';
import { Answer, CopilotContext } from '../../CopilotContext';

const Translate = Locale.getTranslate('components.search-bar');

type CopilotResultProps = {
    answer?: Answer;
    loading: boolean;
    term: string;
}

const CopilotSearchResult = ({ answer, loading, term }: CopilotResultProps) => {
    const { openFromSearch } = useContext(CopilotContext);

    const openDrawer = () => openFromSearch(term, answer);

    const handleShowMoreClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        openDrawer();
    };

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className="plesk-copilot-search-result" onClick={openDrawer}>
            {loading ?
                <ContentLoader className="plesk-copilot-loading-indicator" text={<Translate content={'copilot.loader-text'} />} /> :
                <div>
                    {answer &&
                        <div className="plesk-copilot-search-answer">
                            <Icon src={require('images/AI.svg')} />
                            {answer.able_to_answer && !answer.error ?
                                <div>
                                    <Cuttable collapsed maxHeight="100px">
                                        <Markdown>{answer.content ?? ''}</Markdown>
                                    </Cuttable>
                                    <Link onClick={handleShowMoreClick}><Translate content={'copilot.showMore'} /></Link>
                                </div> : <div>{answer.content || answer.error}</div>}
                        </div>}
                </div>}
        </div>
    );
};

export default CopilotSearchResult;
